/*****
  'is-previous' and 'is-next' classes for Flickity carousels
*****/
Flickity.createMethods.push('_createPrevNextCells');
Flickity.prototype._createPrevNextCells = function () {
  this.on('select', this.setPrevNextCells);
}
Flickity.prototype.setPrevNextCells = function () {
  // remove classes
  changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
  changeSlideClasses(this.nextSlide, 'remove', 'is-next');

  // set slides
  if (this.selectedIndex - 1 < 0) {
    this.previousSlide = this.slides[this.slides.length - 1];
  } else {
    this.previousSlide = this.slides[this.selectedIndex - 1];
  }

  if (this.selectedIndex + 1 === this.slides.length) {
    this.nextSlide = this.slides[0];
  } else {
    this.nextSlide = this.slides[this.selectedIndex + 1];
  }

  // add classes
  changeSlideClasses(this.previousSlide, 'add', 'is-previous');
  changeSlideClasses(this.nextSlide, 'add', 'is-next');
}
function changeSlideClasses(slide, method, className) {
  if (!slide) {
    return;
  }

  slide.getCellElements().forEach(function (cellElem) {
    cellElem.classList[method](className);
  })
}


(function ($) {
  $(function () {

    /*****
      Flickity
    *****/
    if ($('.home-carousel').length) {
      $('.home-carousel').flickity({
        cellSelector: '.home-carousel-item',
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 1500,
        //autoPlay: 1000,
        wrapAround: true,
        imagesLoaded: true,
        fade: true,
        pauseAutoPlayOnHover: false
      });

      // A small hack to recalculate the size of the home-carousel
      $('.home-carousel').flickity('resize');
      setTimeout(function () {
        $('.home-carousel').flickity('resize');
      }, 300);

      $('.home-carousel').on('click staticClick pointerUp dragEnd', function() {
        $('.home-carousel').flickity('playPlayer');
      });
    }


  });
})(jQuery);
